import { useEffect, useRef, useState } from "react";
import { subscribeMusic, getStation, getMyMusic, setMyMusicFiles, nextMyTrack } from "@/lib/audio";
import "./MyMusicPicker.css";

// "My Music": the player picks songs from THIS device. They play only here,
// in this browser — nothing is uploaded to the server.
export default function MyMusicPicker({ compact = false }) {
  const [, setTick] = useState(0);
  const inputRef = useRef(null);
  useEffect(() => subscribeMusic(() => setTick((t) => t + 1)), []);
  if (getStation() !== "mine") return null;
  const { count, current } = getMyMusic();
  return (
    <div className={`mymusic${compact ? " is-compact" : ""}`} data-testid="my-music">
      <button
        type="button"
        className="mymusic-pick"
        onClick={() => inputRef.current && inputRef.current.click()}
        data-testid="my-music-pick"
      >
        {count ? "Choose different songs" : "Choose songs from this device"}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="audio/*"
        multiple
        className="mymusic-input"
        tabIndex={-1}
        aria-hidden="true"
        onChange={(e) => { setMyMusicFiles(e.target.files); e.target.value = ""; }}
        data-testid="my-music-input"
      />
      {count > 0 && (
        <div className="mymusic-now" data-testid="my-music-now">
          <span className="mymusic-title">♪ {current}</span>
          {count > 1 && (
            <button type="button" className="mymusic-next" onClick={nextMyTrack} aria-label="Next song" data-testid="my-music-next">⏭</button>
          )}
        </div>
      )}
      <div className="mymusic-note">Plays only on this device — nothing is uploaded.</div>
    </div>
  );
}
